// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__-9eVi","category_tab":"Projects_category_tab__tW0AO","projects":"Projects_projects__Mqq8x","flex_container":"Projects_flex_container__Ju58H"};